// Modular access catalog for the Admin panel.
// Each entry maps a stable string key → user-facing Turkish label + optional
// group. Admin always sees everything. Staff users see entries whose key is
// present in `user.allowed_modules`. The dashboard is implicitly always on.
//
// Keep keys in sync with AdminLayout.jsx `items` list (moduleKey field).
export const ADMIN_MODULES = [
  { key: "vesikalik",        label: "Vesikalık / Biyometrik Üretici", group: "Üretim" },
  { key: "randevular",       label: "Randevular",                     group: "Günlük İş" },
  { key: "randevu-katalogu", label: "Randevu Kataloğu & Sözleşme",    group: "Günlük İş" },
  { key: "takvim",           label: "Takvim & Kapatma",               group: "Günlük İş" },
  { key: "bildirimler",      label: "Bildirimler",                    group: "Günlük İş" },
  { key: "kisiler",          label: "Kişiler (CRM)",                  group: "Günlük İş" },

  { key: "albumler",         label: "Fotoğraf Seçim Albümleri",       group: "Teslim" },
  { key: "mekanlar",         label: "Mekanlar (Sabit QR)",            group: "Teslim" },
  { key: "salon-hesaplari",  label: "Salon Hesapları (B2B)",          group: "Teslim" },
  { key: "etkinlikler",      label: "Etkinlikler & Yükleme Linkleri", group: "Teslim" },
  { key: "galeri",           label: "Galeri",                         group: "Teslim" },
  { key: "fotuber-medya",    label: "Fotuber Medya",                  group: "Teslim" },

  { key: "finans",           label: "Finans (özet)",                  group: "Finans" },
  { key: "hizmetler",        label: "Hizmetler",                      group: "Katalog" },
  { key: "urun-secenekleri", label: "Tablo & Albüm Modelleri",        group: "Katalog" },
  { key: "indirim-kodlari",  label: "İndirim Kodları",                group: "Katalog" },

  { key: "personel",         label: "Personel Listesi",               group: "Ekip" },
  { key: "reklamlar",        label: "Reklam Alanları",                group: "Pazarlama" },
  { key: "masaustu",         label: "Masaüstü Uygulaması",            group: "Araçlar" },
];

export const ADMIN_MODULE_KEYS = ADMIN_MODULES.map((m) => m.key);
export const ADMIN_MODULE_LABELS = Object.fromEntries(ADMIN_MODULES.map((m) => [m.key, m.label]));

// Decide whether the given user can see a given moduleKey.
// Admin → always true. Dashboard → always true. Staff → key ∈ allowed_modules.
export const canSeeModule = (user, moduleKey) => {
  if (!user) return false;
  if (user.role === "admin") return true;
  if (!moduleKey) return true;   // nav items without a key default to visible for everyone
  if (moduleKey === "dashboard") return true;
  const list = Array.isArray(user.allowed_modules) ? user.allowed_modules : [];
  return list.includes(moduleKey);
};
